export enum userConstants {
  USER_LOGIN = 'USER_LOGIN',
  USER_LOGOUT = 'USER_LOGOUT',
  USER_CHANGE_CREATION_PASSWORD = 'USER_CHANGE_CREATION_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  USER_LOGOUT_INVALID_TOKEN = 'USER_LOGOUT_INVALID_TOKEN',
  EASY_MOBILITY_LANGUAGE = 'EASY_MOBILITY_LANGUAGE',
  USER_REFRESH_TOKEN = 'USER_REFRESH_TOKEN',
}
